import _defineProperty from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 加载中
 * @module $ui/components/my-spin
 */

/**
 * 插槽
 * @member slots
 * @property {string} default 默认插槽，定义需要显示加载的容器
 * @property {string} dot 定义加载中的内容
 */
export default {
  name: 'MySpin',
  /**
   * 属性参数
   * @member props
   * @property {string} [size=default]  组件大小，可选值为 small default large
   * @property {number} [delay=100] 延迟显示加载效果的时间（防止闪烁）
   * @property {string} [tip] 当作为包裹元素时，可以自定义描述文案
   * @property {boolean} [loading=false] 是否为加载中状态
   * @property {boolean} [fit=false] 充满父容器
   */
  props: {
    // 组件大小，可选值为 small default large
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['default', 'large', 'small'].includes(val);
      }
    },
    // 延迟显示加载效果的时间（防止闪烁）
    delay: {
      type: Number,
      default: 100
    },
    // 当作为包裹元素时，可以自定义描述文案
    tip: String,
    // 是否为加载中状态
    loading: Boolean,
    // 充满父容器
    fit: Boolean
  },
  data: function data() {
    this.timerId = null;
    return {
      isDelayOver: false
    };
  },
  computed: {
    spinClasses: function spinClasses() {
      return _defineProperty({}, "is-".concat(this.size), !!this.size);
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'my-spin--nested': !!this.$slots.default,
        'is-fit': this.fit
      };
    },
    containerClasses: function containerClasses() {
      return {
        'is-blur': this.loading && this.isDelayOver
      };
    }
  },
  watch: {
    loading: {
      immediate: true,
      handler: function handler(val) {
        val && this.setupLoading();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timerId);
  },
  methods: {
    setupLoading: function setupLoading() {
      var _this = this;
      clearTimeout(this.timerId);
      this.isDelayOver = false;
      if (this.delay > 0) {
        this.timerId = setTimeout(function () {
          _this.isDelayOver = true;
        }, this.delay);
      } else {
        this.isDelayOver = true;
      }
    }
  }
};